let Api = {
    "STAT_PRODUCTSALELIST": '/b2b/w/stat/productSaleList', //商品销售排行 Top10
    "STAT_PRODUCTCOUNT": '/b2b/w/stat/productCount', //商品统计
    "STAT_PRODUCTALYPAGE": '/b2b/w/stat/productAlyPage', //商品分析报表
    "STAT_CUSTOMERCOUNT": '/b2b/w/stat/customerCount', //客户统计
    "STAT_ANALYSIS": '/b2b/w/stat/analysis', //买家用户分析报表
    "STAT_ANALFINDSELLERANALYSISLIST": '/b2b/w/stat/findSellerAnalysisList', //商家用户分析报表
    "STAT_TRENDCHANGE": '/b2b/w/stat/trendChange', //用户变化趋势
    "STAT_PRODUCTTRENDCHANGE": '/b2b/w/stat/productTrendChange', //商品变化趋势
    "STAT_PRODACTIVERATECOUNT": '/b2b/w/stat/prodActiveRateCount', //商品统计-获取活跃商品数，新品上架率
   

    
  }
  module.exports = Api